<template>
  <div>
    <div class="form-group margin-bottom-20">
      <div class="margin-bottom-5"><strong>Direct link to your form:</strong></div>
      <div class="input-group">
        <div class="input-group-control">
          <input type="text" class="form-control" :value="shareUrl" id="referral-share-url"
                 disabled="disabled">
        </div>
        <span class="input-group-btn btn-right">
            <button class="btn green" type="button" @click="copyReferralShareUrl">Copy</button>
        </span>
      </div>
    </div>

    <div class="margin-bottom-20 text-center"><strong><em>or</em></strong></div>

    <div class="form-group">
      <div class="margin-bottom-5"><strong>Embed this form to a website:</strong></div>
      <div class="input-group">
        <div class="input-group-control">
          <textarea class="form-control" disabled="disabled" rows="3" id="referral-share-iframe-code">{{shareEmbedCode}}</textarea>
        </div>
        <span class="input-group-btn btn-right">
          <button class="btn green" type="button" id="copy-iframe-btn"
                  @click="copyReferralShareIframeCode">Copy</button>
        </span>
      </div>
      <div>Copy and paste the above code into an HTML page on your website.</div>
    </div>
  </div>
</template>

<script>
import { computed } from 'vue';

export default {
  props: {
    url: {
      type: String,
      required: true,
    },
    uid: {
      type: String,
      required: true,
    }
  },
  setup(props) {
    const copyReferralShareUrl = () => {
      let url = document.querySelector('#referral-share-url');
      url.removeAttribute('disabled');
      url.select();
      document.execCommand('copy');
      window.getSelection().removeAllRanges();
      url.setAttribute('disabled', true);
    }
    const copyReferralShareIframeCode = () => {
      let url = document.querySelector('#referral-share-iframe-code');
      url.removeAttribute('disabled');
      url.select();
      document.execCommand('copy');
      window.getSelection().removeAllRanges();
      url.setAttribute('disabled', true);
    }

    const shareUrl = computed(() => `https://${props.url}/referral/${props.uid}`)
    const shareEmbedCode = computed(() => `<iframe src="https://${props.url}/embed-casemgr-referral/${props.uid}" frameborder="0" width="800" height="600"></iframe>`)

    return {
      shareUrl,
      shareEmbedCode,
      copyReferralShareUrl,
      copyReferralShareIframeCode
    }
  }
}
</script>

<style scoped lang="scss">
#referral-share-iframe-code, #copy-iframe-btn {
  height: 75px;
}
</style>



// WEBPACK FOOTER //
// VueFormShareLinks.vue?e4e04676